<template lang="pug">
  div(style="position: relative")
    b-badge(
      :id="uid"
      @click="showOptions"
      :style="{backgroundColor: selected? selected.color:'#2ecc71', position: 'relative'}"
      tag="div"
    ) {{text}}
    b-popover(
      custom-class="shadow state-popover"
      boundary="window"
      :target="uid" 
      placement="bottom"
      :show="showPopover"
    )
      b-badge.mb-2(
        v-for="state in states"
        @click="onSelect(state)"
        :style="{backgroundColor: state.color}"
        tag="div"
      ) {{state.name}}
    b-modal(ref="optional-value-modal" @ok="onSelectWithOptionalValue" hide-header ok-title="Guardar" @cancel="optionalValue=''")
      b-form(@submit.stop.prevent)
        b-form-group(label="Valor" label-for="value-input")
          b-input-group(prepend="$")
            b-form-input(v-model="optionalValue" type="number" id="value-input")
</template>

<script>
export default {
  props: {
    id: String,
    placeholder: String,
    value: Object,
    states: {
      type: Array
    }
  },
  data () {
    return {
      optionalValue: null,
      auxState: null,
      selected: this.value,
      showPopover: false,
      uid: new Date().getUTCMilliseconds().toString() + Math.random()
    }
  },
  methods: {
    formatValue (value) {
      const isNegative = value < 0
      value = value.toString()
      value = value.replaceAll('-','')
      let format = ''
      for (let i = 0; i < value.length; i++) {
        const e = value.charAt(value.length - i - 1)
        format = e.concat(format)
        if ((i + 1) % 3 === 0 && i + 1 !== value.length){
          format = '.'.concat(format)
        }
      }
      return isNegative ? '- $'.concat(format) : '$'.concat(format)
    },
    onSelect (state) {
      if (!state.hasValue) {
        this.selected = state
        this.$emit('input', state)
        this.$emit('change', state)
      } else {
        this.auxState = state
        this.optionalValue = this.selected.value
        this.$refs['optional-value-modal'].show()
      }
    },
    onSelectWithOptionalValue () {
      this.selected = this.auxState
      if (this.optionalValue) {
        this.optionalValue = Math.trunc(this.optionalValue)
      }
      this.selected.value = this.optionalValue
      this.$emit('input', this.selected)
      this.$emit('change', this.selected)
      this.optionalValue = null
      this.auxState = null
    },
    setFocus () {
      this.$refs.input.focus()
    },
    hideOptions () {
      this.showPopover = false
      window.removeEventListener('click', this.hideOptions,true)
    },
    showOptions () {
      this.showPopover = true
      window.addEventListener('click', this.hideOptions, true)
    }
  },
  computed: {
    text () {
      if (this.selected) {
        if (this.selected.value) {
          return this.formatValue(this.selected.value)
        } 
        return this.selected.name
      }
      return this.placeholder
    }
  },
  watch: {
    value () {
      this.selected = this.value
    }
  },
  created () {
    if(this.id) this.uid = this.id
  }
}
</script>

<style lang="scss" scoped>
.badge {
  width: 124px;
  height: 25px;
  font-size: 14px;
  display: block;
  cursor: pointer;
  font-weight: normal;
  padding: 6px;
}
</style>

<style lang="scss">
.state-popover {
  $border-color: var(--primary);

  border: 2px solid $border-color;;

  .arrow::before {
    border-bottom-color: $border-color !important;
    top: -1px;
  }
  .arrow::after {
    top: 2px;
  }
}
</style>
